<template>
  <div id="app">
    <!--导航条-->
    <gheader type="home"></gheader>
    <!--logo一行-->
    <glogo></glogo>
    <!--红色导航-->
    <grednav type="home"></grednav>
    <div class="row-agreement">
      <div class="main-width">
        <div id="agreement">
          <h2 id="title">供应商操作手册</h2>
          <div id="source">
            <p></p>
          </div>
          <div id="content">

            <h4>一、城投库内供应商信息变更操作</h4>
            <p class="text-padding">城投信息门户：<a href="http://yc.yonyoucloud.com/smi/cashome.html">https://yc.yonyoucloud.com/smi/cashome.html</a></p>
            <p class="text-padding">登录后选择进入工作台（推荐使用谷歌浏览器）</p>
            <div class="manual-img">
              <img src="static/imgs/manual_1_1.png" alt="">
            </div>
            <p class="text-padding">城投库内供用商若出现企业信息变更情况，可先查看原供应商信息后，</p>
            <p class="text-padding">点击客户管理——我的变更申请——发起变更</p>
            <div class="manual-img">
              <img src="static/imgs/manual_1_2.png" alt="">
            </div>
            <p class="text-padding">选择对应的客户变更档案，确定</p>
            <div class="manual-img">
              <img src="static/imgs/manual_1_3.png" alt="">
            </div>
            <p class="text-padding">页面内容同供应商申请页面，企业唯一性字段控制不能修改，修改后信息需要在进行供应商审核后才会进入供应商档案。同时有些信息可以不需要审核直接修改，如联系人，企业简介等，直接在企业信息管理中修改即可。（红色星号<label style="color:red">※</label>为必填项，其他内容请根据采购商要求进行填写）</p>
            <div class="manual-img">
              <img src="static/imgs/manual_1_4.png" alt="">
            </div>
            <p class="text-padding">全部信息填写完毕后，下拉至页面底部，请先点击暂存后，再点击提交审核。</p>
            <p class="text-padding">提交后在客户管理——我的变更申请——待审核 内查看</p>
            <h5 style="font-weight:700">供应商查看审核进度：</h5>
            <p class="text-padding">①	当状态由待审核变更为<label style="font-weight:700">已变更</label>则代表变更完成</p>
            <div class="manual-img">
              <img src="static/imgs/manual_1_5.png" alt="">
            </div>
            <p class="text-padding">②	当状态由待审核变更为<label style="color:red">已驳回/二次审核驳回</label>，请点击该条变更记录<label style="font-weight:700">查看</label>驳回理由，根据采购商要求<label style="font-weight:700">再次编辑</label>进行<label style="font-weight:700">提交</label></p>
            <div class="manual-img">
              <img src="static/imgs/manual_1_6.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual_1_7.png" alt="">
            </div>

            <h4>二、供应商招标</h4>
            <h5>1.供应商报名</h5>
            <p class="text-padding">供应商报名分两种情况，一种是邀请报名，一种是直接报名。</p>
            <h6>1.1 邀请报名</h6>
            <p class="text-padding">直接登录账号即可，登录账户，进入工作台，投标管理，在报名中查看“待报名”的数量，点击“报名”按钮，填写相关资料报名即可。</p>
            <div class="manual-img">
              <img src="static/imgs/manual12.png" alt="">
            </div>
            <h6>1.2 直接报名</h6>
            <p class="text-padding">在友云采招采门户，查询招标信息，点击相关招标信息，点击我要报名，然后登录后，点击报名，填写相关资料后，点击“报名”即可</p>
            <div class="manual-img">
              <img src="static/imgs/manual_6.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual14.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual_7.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual16.png" alt="">
            </div>
            <h5>2.供应商招标</h5>
            <h6>2.1 供应商投标</h6>
            <p class="text-padding">
              登录账号如果在招标管理，在待投标里可以看到可以投标的数量，上传附件，输入报价，点击“保存”“投标”按钮即可。采购商如果对报价不满意，可以发起谈判，然后供应商可以在“待投标”进行报价。</p>
            <div class="manual-img">
              <img src="static/imgs/manual17.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual18.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual19.png" alt="">
            </div>
            <h5>3.中标通知</h5>
            <p class="text-padding">中标后供应商账号和招标门户都会收到中标通知。</p>
            <div class="manual-img">
              <img src="static/imgs/manual20.png" alt="">
            </div>
            <div class="manual-img">
              <img src="static/imgs/manual_8.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import gheader from 'components/G-header'
  import glogo from 'components/G-logo'
  import grednav from 'components/G-rednav'
  import {apiLinks} from '../../api/links.js'

  export default {
    name: 'app',
    components: {
      gheader,
      glogo,
      grednav
    },
    data () {
      return {}
    },
    methods: {
      enterlink: function () {
        let str = window.location.href
        let array = str.split('?')
        if (array[1] === 'register') {
          window.location.href = apiLinks.register
        } else if (array[1] === 'applyFor') {
          window.location.href = apiLinks.suppliersFor
        }
      }
    }
  }
</script>
<style>
  #agreement {
    width: 980px;
    min-height: 650px;
    margin: 50px auto;
    box-shadow: 0 2px 6px #999;
    _border: 1px #dedede solid;
    padding: 15px;
  }

  #title {
    text-align: center !important;
    font-size: 26px;
    font-weight: 400;
    font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  #source > p {
    width: 950px;
    margin: 0 auto;
    border-bottom: 1px solid #E5E5E5;
    margin-bottom: 20px;
    color: #999;
    line-height: 30px;
    padding-bottom: 5px;
    text-align: center;
  }

  #content > p {
    font-size: 12px;
    font-family: "Microsoft YaHei", Arial, Verdana, sans-serif;
    background: #ffffff;
    color: #333;
    margin: 0 0 10px;
    line-height: 30px;
  }

  .manual-img {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
  }

  .manual-img > img {
    width: 800px;
  }

  .text-padding {
    padding-left: 24px;
    padding-right: 24px;
  }

  #content h5, #content h6 {
    padding-left: 24px;
    padding-right: 24px;
    margin-top: 20px;
  }

  #content h4 {
    margin-top: 20px;
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// manual.vue?eb636062